import AuthService from "../services/security/auth.service"
import informationService from '../services/system';

const setAccountId = (item, field, previousValue, data, setField, group, info, requestTrxLineTypeId3, requestTrxLineTypeId4, requestTrxLineTypeId5, searchFieldSource) => {
    try {
        let validate = false;
        if (item) {
            let idField = item.id;
            let currentValue = field[idField];
            if (currentValue !== previousValue[idField]) {
                validate = true;
            }
        }

        if ((validate) || (item === null && previousValue === null)) {
            let validateTable = false;
            if (item) {
                if (item.table === 'trx' || item.table === 'trxLine') {
                    validateTable = true;
                }
            }
            if (item === null) {
                validateTable = true;
            }

            if (validateTable) {
                const user = AuthService.getCurrentUser();
                let arrayRequest = [];
                //TRXLINE TYPE ID1
                let requestTrxLineTypeId1 = {};
                requestTrxLineTypeId1.doc = data.id;
                requestTrxLineTypeId1.trxLineTypeId = '1';
                requestTrxLineTypeId1.isGuarantee = '0';
                //TRXLINETYPEID 2
                let requestTrxLineTypeId2 = {};
                requestTrxLineTypeId2.doc = data.id;
                requestTrxLineTypeId2.trxLineTypeId = '2';
                requestTrxLineTypeId2.isGuarantee = '0';
                let currencyId;
                let paymentSystemId;

                data.crud.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {
                        let idfield = itemFields.id;

                        if (field[idfield]) {
                            switch (itemFields.idFieldTable) {
                                case 'currencyId':
                                    requestTrxLineTypeId1.currencyId = field[idfield].id;
                                    requestTrxLineTypeId2.currencyId = field[idfield].id;
                                    currencyId = field[idfield].id;
                                    break;
                                case 'agentId':
                                    requestTrxLineTypeId2.entityPropertyId = field[idfield].id;
                                    requestTrxLineTypeId1.agentId = field[idfield].id;
                                    break;
                                case 'isGuarantee':
                                    //requestTrxLineTypeId2.isGuarantee = field[idfield];
                                    //requestTrxLineTypeId1.isGuarantee = field[idfield];
                                    break;
                                case 'entityPropertyId':
                                    requestTrxLineTypeId1.entityPropertyId = field[idfield].id;
                                    break;
                                case 'paymentSystemId':
                                    requestTrxLineTypeId1.paymentSystemId = field[idfield].id;
                                    requestTrxLineTypeId2.paymentSystemId = field[idfield].id;
                                    paymentSystemId = field[idfield].id;
                                    break;
                                default:
                                    break;
                            }
                        }
                    })
                })

                arrayRequest.push(requestTrxLineTypeId2);
                arrayRequest.push(requestTrxLineTypeId1);

                let nameGroup3 = trxLineGroup(group, 3);

                for (let a1 = 0; a1 < nameGroup3.length; a1++) {
                    if (group[nameGroup3[a1]] && requestTrxLineTypeId3 === null) {
                        for (let y = 0; y < group[nameGroup3[a1]].length; y++) {
                            //TRXLINETYPEID 3
                            let requestTrxLineTypeId3 = {};
                            requestTrxLineTypeId3.doc = data.id;
                            requestTrxLineTypeId3.trxLineTypeId = '3';
                            requestTrxLineTypeId3.currencyId = currencyId;
                            requestTrxLineTypeId3.paymentSystemId = paymentSystemId;
                            for (let i = 0; i < group[nameGroup3[a1]][y].fields.length; i++) {
                                if (group[nameGroup3[a1]][y].fields[i].idFieldTable === 'itemPropertyId') {
                                    let idField = group[nameGroup3[a1]][y].fields[i].id;
                                    if (field[idField])
                                        requestTrxLineTypeId3.itemPropertyId = field[idField].id;
                                    requestTrxLineTypeId3.line = y.toString();
                                }
                            }
                            arrayRequest.push(requestTrxLineTypeId3);
                        }
                    } else {
                        if (requestTrxLineTypeId3 !== null) {
                            for (let y = 0; y < requestTrxLineTypeId3.length; y++) {
                                requestTrxLineTypeId3[y].doc = data.id;
                                requestTrxLineTypeId3[y].trxLineTypeId = '3';
                                requestTrxLineTypeId3[y].currencyId = currencyId;
                                requestTrxLineTypeId3[y].paymentSystemId = paymentSystemId;
                                arrayRequest.push(requestTrxLineTypeId3[y]);
                            }
                        }
                    }
                }
                let nameGroup4 = trxLineGroup(group, 4);

                for (let a1 = 0; a1 < nameGroup4.length; a1++) {
                    if (group[nameGroup4[a1]] && requestTrxLineTypeId4 === null) {
                        for (let y = 0; y < group[nameGroup4[a1]].length; y++) {
                            //TRXLINETYPEID 4
                            let requestTrxLineTypeId4 = {};
                            requestTrxLineTypeId4.doc = data.id;
                            requestTrxLineTypeId4.trxLineTypeId = '4';
                            requestTrxLineTypeId4.currencyId = currencyId;
                            requestTrxLineTypeId4.paymentSystemId = paymentSystemId;
                            for (let i = 0; i < group[nameGroup4[a1]][y].fields.length; i++) {
                                if (group[nameGroup4[a1]][y].fields[i].idFieldTable === 'itemPropertyId') {
                                    let idField = group[nameGroup4[a1]][y].fields[i].id;
                                    if (field[idField])
                                        requestTrxLineTypeId4.itemPropertyId = field[idField].id;
                                    requestTrxLineTypeId4.line = y.toString();
                                }
                            }
                            arrayRequest.push(requestTrxLineTypeId4);
                        }
                    } else {
                        if (requestTrxLineTypeId4 !== null) {
                            for (let y = 0; y < requestTrxLineTypeId4.length; y++) {
                                requestTrxLineTypeId4[y].doc = data.id;
                                requestTrxLineTypeId4[y].trxLineTypeId = '4';
                                requestTrxLineTypeId4[y].currencyId = currencyId;
                                requestTrxLineTypeId4[y].paymentSystemId = paymentSystemId;
                                arrayRequest.push(requestTrxLineTypeId4[y]);
                            }
                        }
                    }
                }
                let nameGroup5 = trxLineGroup(group, 5);
                for (let a1 = 0; a1 < nameGroup5.length; a1++) {
                    if (group[nameGroup5[a1]] && requestTrxLineTypeId5 === null) {
                        for (let y = 0; y < group[nameGroup5[a1]].length; y++) {
                            //TRXLINETYPEID 5
                            let requestTrxLineTypeId5 = {};
                            requestTrxLineTypeId5.doc = data.id;
                            requestTrxLineTypeId5.trxLineTypeId = '5';
                            requestTrxLineTypeId5.currencyId = currencyId;
                            requestTrxLineTypeId5.paymentSystemId = paymentSystemId;
                            for (let i = 0; i < group[nameGroup5[a1]][y].fields.length; i++) {
                                if (group[nameGroup5[a1]][y].fields[i].idFieldTable === 'itemPropertyId') {
                                    let idField = group[nameGroup5[a1]][y].fields[i].id;
                                    if (field[idField])
                                        requestTrxLineTypeId5.itemPropertyId = field[idField].id;
                                    requestTrxLineTypeId5.line = y.toString();
                                }
                            }
                            arrayRequest.push(requestTrxLineTypeId5);
                        }
                    } else {
                        if (requestTrxLineTypeId5 !== null) {
                            for (let y = 0; y < requestTrxLineTypeId5.length; y++) {
                                requestTrxLineTypeId5[y].doc = data.id;
                                requestTrxLineTypeId5[y].trxLineTypeId = '5';
                                requestTrxLineTypeId5[y].currencyId = currencyId;
                                requestTrxLineTypeId5[y].paymentSystemId = paymentSystemId;
                                arrayRequest.push(requestTrxLineTypeId5[y]);
                            }
                        }
                    }
                }

                informationService.searchAccount(user.data.instance, arrayRequest).then((response) => {
                    for (let b = 0; b < response.data.length; b++) {
                        let trxLineTypeId = response.data[b].trxLineTypeId;
                        if (Number(trxLineTypeId) === 2) {

                            let nameGroup2 = trxLineGroup(group, 2);
                            for (let a1 = 0; a1 < nameGroup2.length; a1++) {
                                //if (group.trxLine2) {
                                if (group[nameGroup2[a1]]) {

                                    for (let y = 0; y < group[nameGroup2[a1]].length; y++) {
                                        for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                            if (group[nameGroup2[a1]][y].fields[i].idFieldTable === 'accountId' || group[nameGroup2[a1]][y].fields[i].idFieldTable === 'entityPropertyId') {
                                                let comparate;
                                                if (group[nameGroup2[a1]][y].fields[i].idFieldTable === 'accountId')
                                                    comparate = response.data[b].accountId;
                                                if (group[nameGroup2[a1]][y].fields[i].idFieldTable === 'entityPropertyId')
                                                    comparate = response.data[b].entityPropertyId;

                                                let idField = group[nameGroup2[a1]][y].fields[i].id;
                                                let sourceTable = group[nameGroup2[a1]][y].fields[i].idFieldTable.replace('Id', '');
                                                if (idField) {
                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === sourceTable) {
                                                            if (Number(comparate) === Number(itemInfo.id)) {

                                                                let validate = false;
                                                                if (!field[idField])
                                                                    validate = true;
                                                                else {
                                                                    if (Number(field[idField].id) !== Number(itemInfo.id)) {
                                                                        validate = true
                                                                    }
                                                                }

                                                                if (validate === true) {
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: {
                                                                            id: itemInfo.id,
                                                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                        }
                                                                    }), []);
                                                                    if (searchFieldSource !== null)
                                                                        searchFieldSource(group[nameGroup2[a1]][y].fields[i], itemInfo.id);
                                                                }
                                                            }

                                                        }
                                                    })
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                        }

                        if (Number(trxLineTypeId) === 3 || Number(trxLineTypeId) === 4 || Number(trxLineTypeId) === 5) {

                            let nameGroups = trxLineGroup(group, trxLineTypeId);


                            //let nameGroup = 'trxLine' + trxLineTypeId;
                            for (let a1 = 0; a1 < nameGroups.length; a1++) {

                                if (group[nameGroups[a1]]) {
                                    for (let y = 0; y < group[nameGroups[a1]].length; y++) {
                                        if (y === Number(response.data[b].line)) {

                                            for (let i = 0; i < group[nameGroups[a1]][y].fields.length; i++) {
                                                if (group[nameGroups[a1]][y].fields[i].idFieldTable === 'accountId' || group[nameGroups[a1]][y].fields[i].idFieldTable === 'entityPropertyId') {
                                                    let comparate;
                                                    if (group[nameGroups[a1]][y].fields[i].idFieldTable === 'accountId')
                                                        comparate = response.data[b].accountId;
                                                    if (group[nameGroups[a1]][y].fields[i].idFieldTable === 'entityPropertyId')
                                                        comparate = response.data[b].entityPropertyId;

                                                    let idField = group[nameGroups[a1]][y].fields[i].id;

                                                    //let sourceTable = group[nameGroups[a1]][y].fields[i].idFieldTable.replace('Id', '');
                                                    //console.log('sourceTable-> ' + sourceTable)
                                                    if (idField) {
                                                        info.forEach((itemInfo) => {
                                                            if (comparate !== 0) {
                                                                //if (itemInfo.source === sourceTable) {
                                                                if (itemInfo.source === group[nameGroups[a1]][y].fields[i].sourceSelect) {//modificacion 18 03 25
                                                                    if (Number(comparate) === Number(itemInfo.id)) {

                                                                        let validate = false;
                                                                        if (!field[idField])
                                                                            validate = true;
                                                                        else {
                                                                            if (Number(field[idField].id) !== Number(itemInfo.id)) {
                                                                                validate = true
                                                                            }
                                                                        }

                                                                        if (validate === true) {
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: {
                                                                                    id: itemInfo.id,
                                                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                }
                                                                            }), []);
                                                                            if (searchFieldSource !== null)

                                                                                searchFieldSource(group[nameGroups[a1]][y].fields[i], itemInfo.id);
                                                                        }
                                                                    }
                                                                }
                                                            } else {
                                                                let sourceField = response.data[b].sourceField;
                                                                data.crud.boxes.forEach((itemBoxes) => {
                                                                    itemBoxes.fields.forEach((itemFields) => {
                                                                        let idfieldFlag = itemFields.id;
                                                                        if (field[idfieldFlag]) {
                                                                            if (itemFields.idFieldTable === sourceField) {
                                                                                let value = field[idfieldFlag];
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: value
                                                                                }), []);
                                                                                if (searchFieldSource !== null)

                                                                                    searchFieldSource(itemFields, value);

                                                                            }

                                                                        }
                                                                    })
                                                                })
                                                            }
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }


                        if (Number(trxLineTypeId) === 1) {


                            let nameGroup1 = trxLineGroup(group, 1);
                            for (let a1 = 0; a1 < nameGroup1.length; a1++) {
                                if (group[nameGroup1[a1]]) {

                                    for (let y = 0; y < group[nameGroup1[a1]].length; y++) {
                                        for (let i = 0; i < group[nameGroup1[a1]][y].fields.length; i++) {
                                            let idField = group[nameGroup1[a1]][y].fields[i].id;

                                            switch (group[nameGroup1[a1]][y].fields[i].idFieldTable) {

                                                case 'accountId':
                                                    if (idField) {
                                                        info.forEach((itemInfo) => {
                                                            //if (itemInfo.source === group[nameGroup1[a1]][y].fields[i].idFieldTable.replace('Id', '')) {
                                                            if (itemInfo.source === group[nameGroup1[a1]][y].fields[i].sourceSelect) {
                                                                if (Number(response.data[b].accountId) === Number(itemInfo.id)) {

                                                                    let validate = false;
                                                                    if (!field[idField])
                                                                        validate = true;
                                                                    else {
                                                                        if (Number(field[idField].id) !== Number(itemInfo.id)) {
                                                                            validate = true
                                                                        }
                                                                    }

                                                                    if (validate === true) {

                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);
                                                                        if (searchFieldSource !== null)

                                                                            searchFieldSource(group[nameGroup1[a1]][y].fields[i], itemInfo.id);

                                                                    }

                                                                }

                                                            }
                                                        })
                                                    }
                                                    break;
                                                default:
                                                    break;
                                            }

                                        }
                                    }

                                }
                            }
                        }
                    }

                }).catch((error) => {
                    console.log(error);
                })
            }
        }

    } catch (error) {
        console.log('error account id' + error);
    }

}

const trxLineGroup = (group, trxLineTypeId) => {
    let nameGroup = [];
    for (let key in group) {
        if (group[key]) {
            let lineType = 0;
            for (let d = 0; d < group[key][0].fields.length; d++) {
                if (group[key][0].fields[d].idFieldTable === 'trxLineTypeId') {

                    lineType = group[key][0].fields[d].defaultValue
                }
            }
            if (Number(lineType) === Number(trxLineTypeId)) {
                nameGroup.push(key);
            }
        }
    }
    return nameGroup;
}

export default setAccountId;